// File contains the init() function to initialise reoako on page load.
// Refferences the API_KEY and API_DOMAIN from the settings > reoako.py file in the back end.

import Reoako from '@octavenz/reoako';

export default function init() {
    const apiDomain = document.querySelector('[name=reoako-api-domain]').getAttribute('content');
    const apiKey = document.querySelector('[name=reoako-api-key]').getAttribute('content');
    if (apiKey) {
        Reoako.init({
            apiDomain,
            apiKey,
            track: (type, detail) => {
        // optional. hook into your analytics when events occur
        if (typeof detail === 'string') {
          console.log(type, detail);
        } else if ('en' in detail) {
          console.log(type, `${detail.en} | ${detail.mi}`);
        }
      },
        });
    }
}
